import assetPath from '/opt/actions-runner/_work/crate/crate/packages/startpage-logged-out/native-apps-section/src/assets/illustration-native-app-section.jpg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')